var map = {
	"./bgcdash.png": "4ec5",
	"./dataanalysis.png": "33c2",
	"./electroniccertificate.png": "954e",
	"./examination.png": "f1a4",
	"./explorer.png": "11c9",
	"./instructor.png": "4684",
	"./policeTraining.png": "65e5",
	"./portal.png": "fd78",
	"./questionnaire.png": "4cb5",
	"./remedium.png": "d768",
	"./systemmanagement.png": "7e5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1450";